import {Suspense} from "react";
import {Helmet} from "react-helmet-async";

import {useCurrentUserContext} from "@/components/context/hooks.ts";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {LoadingContainer} from "@/components/placeholder/LoadingContainer.tsx";
import {Redirect} from "@/components/router/Redirect.tsx";
import {MAINTENANCE_SCHEDULES} from "@/lib/featureFlags.ts";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {EditMaintenanceScheduleContent} from "@/pages/maintenance/maintenance-edit/EditMaintenanceScheduleContent.tsx";

export const EditMaintenanceSchedulePage = () => {
  const {userHasFeature} = useCurrentUserContext();
  if (!userHasFeature(MAINTENANCE_SCHEDULES)) return <Redirect url={"/checks"} />;

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={"Edit Maintenance Schedule"}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <Helmet>
        <title>Edit Maintenance Schedule</title>
      </Helmet>
      <Suspense fallback={<LoadingContainer />}>
        <EditMaintenanceScheduleContent />
      </Suspense>
    </UpErrorBoundary>
  );
};
